const BHASHINI_API_URL = 'https://meity-auth.ulcacontrib.org/ulca/apis/v0/model/getModelsPipeline';
const BHASHINI_COMPUTE_URL = 'https://dhruva-api.bhashini.gov.in/services/inference/pipeline';

class BhashiniService {
  constructor() {
    this.authToken = null;
    this.pipelineId = null;
  }

  async authenticate() {
    try {
      const response = await fetch('https://meity-auth.ulcacontrib.org/ulca/apis/asr/v1/model/getModelsPipeline', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'userID': 'rajshri.mallabadi@gmail.com',
          'ulcaApiKey': 'Madmed!23'
        },
        body: JSON.stringify({
          "pipelineTasks": [
            {
              "taskType": "translation",
              "config": {
                "language": {
                  "sourceLanguage": "en",
                  "targetLanguage": "hi"
                }
              }
            }
          ],
          "pipelineRequestConfig": {
            "pipelineId": "64392f96daac500b55c543cd"
          }
        })
      });
      
      const data = await response.json();
      this.authToken = data.pipelineResponseConfig?.[0]?.config?.[0]?.serviceId;
      return data;
    } catch (error) {
      console.error('Bhashini auth failed:', error);
      return null;
    }
  }

  async translateText(text, sourceLang = 'en', targetLang = 'hi') {
    try {
      if (!this.authToken) {
        await this.authenticate();
      }

      const response = await fetch(BHASHINI_COMPUTE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.authToken
        },
        body: JSON.stringify({
          "pipelineTasks": [
            {
              "taskType": "translation",
              "config": {
                "language": {
                  "sourceLanguage": sourceLang,
                  "targetLanguage": targetLang
                },
                "serviceId": this.authToken
              }
            }
          ],
          "inputData": {
            "input": [
              {
                "source": text
              }
            ]
          }
        })
      });

      const data = await response.json();
      return data.pipelineResponse?.[0]?.output?.[0]?.target || text;
    } catch (error) {
      console.error('Translation failed:', error);
      return text;
    }
  }
}

export default new BhashiniService();